import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Helper } from '../../Helper';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from '../../CustomValidators';

@Component({
  selector: 'app-payment-popup',
  templateUrl: './payment-popup.component.html',
  styleUrls: ['./payment-popup.component.css']
})
export class PaymentPopupComponent implements OnInit {
  form:any;
  invoice_id="";
  url:any="admin/inspection-schduled";
  constructor(public dialogRef: MatDialogRef<PaymentPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public Helper:Helper ) { 
      console.log(data)
      let user= this.Helper.get("user");
      this.data=data;
      let finalAmount=0;
        
      if(data.products){
        for(let pro of data.products){
          finalAmount+=  pro.amount;
        }
      }
      else if(data.invoice){

        finalAmount=data.invoice.amount;
       this.invoice_id=data.invoice.id;
      }
      else if(data.statement){

        finalAmount=data.statement.expectedAmount;
        
        
      }
      this.form = new FormGroup({
        country_code:new FormControl({value: "254", disabled: true}, []),
        invoice_id:  new FormControl(this.invoice_id, []),
        expected_amount:  new FormControl({value: finalAmount, disabled: true}, [Validators.required,]),
         amount:  new FormControl(finalAmount, [Validators.required,]),
        // mobile_no:  new FormControl(data.mobile_no||user.phone_no, [Validators.required,]),
        mobile_no:  new FormControl(data.mobile_no||user.phone_no, [Validators.required,]),
        
        products:new FormControl(this.data.products? JSON.stringify(this.data.products):"")
      });

    }

  ngOnInit() {
    // this.loading=true;
   
    
    // if(this.invoice_id==""){
    //   return false;
    // }
    // this.Helper.makeRequest("check-pending-invoices",{a:1},"post",{toast:false}).
    // subscribe((data)=>{ 
    //   if(data.data){
    //     this.dialogRef.close(false);
    //     this.Helper.toast("You have some pending invoices please pay them first in payment section.","error");
    //   }

    // },(err)=>{
    //   this.Helper.showServerErrors(err.error.errors,this.form);
    //   this.Helper.toast(err.error.message,"error")
    //   this.loading=false;
    // });
  }
  getErrorMessage(name) {
    return this.Helper.validationErrors(this.form.get(name));
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  loading=false;
  submit(){
    console.log(this.form.valid,this.form)
    if(!this.form.valid ){
      return 1;
    }
    if(this.form.value.amount<1 ){
     return this.Helper.toast("Please enter amount greater then KES 0");
    }
    this.loading=true;
    
    
    let form=this.form.value;
    form.mobile_no="254"+parseInt(form.mobile_no);
      this.Helper.makeRequest("pay-invoice",form,"post",{toast:false}).subscribe(d=>{
        if(d.status){
          this.Helper.toast("Payment request sent succcessfully, please complete the payment and than refresh the page.");

          this.dialogRef.close(d);
        }
        else{
          this.Helper.toast(d.message,"error");
        
          this.dialogRef.close(false);
        }
        this.loading=false;
      },(err)=>{
        console.log(err.error);
       
        this.Helper.showServerErrors(err.error.errors,this.form);
        this.Helper.toast(err.error.message,"error")
        this.loading=false;
        this.Helper.showLoader(false); 
         
      })
     
    
    
  }

}
